export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/LV-ffa5ca31881e44464136e676b05fc0a6.png";